function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnexpectedErrorOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120.548,
  height: 136.704
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5036"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4142"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 787"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 772"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 777"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon ionic-ios-document"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.318 3.937H18.089A10.81 10.81 0 0 0 7.313 14.714v113.151a10.81 10.81 0 0 0 10.776 10.776h80.822a10.81 10.81 0 0 0 10.776-10.776V37.481z",
  "data-name": "Path 1733",
  style: {
    stroke: "#e7792b",
    strokeWidth: 2,
    fill: "none"
  },
  transform: "translate(-6.313 -2.937)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-15648.182 5780.681h50.654",
  "data-name": "Path 1741",
  style: {
    strokeWidth: 6,
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none"
  },
  transform: "translate(15667.202 -5666.08)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-15648.181 5780.681h42.953",
  "data-name": "Path 1742",
  style: {
    strokeWidth: 6,
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none"
  },
  transform: "translate(15667.202 -5684.049)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-15648.182 5780.681h29.092",
  "data-name": "Path 1743",
  style: {
    strokeWidth: 6,
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none"
  },
  transform: "translate(15667.202 -5702.018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-15648.182 5780.681h16.742",
  "data-name": "Path 1744",
  style: {
    strokeWidth: 6,
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none"
  },
  transform: "translate(15667.202 -5719.986)"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m22.294 0 22.294 22.97H0z",
  "data-name": "Polygon 3",
  style: {
    fill: "#e7792b"
  },
  transform: "rotate(-138 51.663 9.987)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4143"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.173,
  cy: 17.173,
  r: 17.173,
  "data-name": "Ellipse 4",
  style: {
    fill: "#e7792b"
  },
  transform: "translate(86.202 64.299)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 798",
  transform: "translate(101.065 71.731)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M715.722-4758.285v11.606",
  "data-name": "Path 1752",
  style: {
    strokeWidth: 4,
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none"
  },
  transform: "translate(-713.723 4758.285)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.027,
  cy: 2.027,
  r: 2.027,
  "data-name": "Ellipse 38",
  style: {
    fill: "#fff"
  },
  transform: "translate(0 15.902)"
})))));
export { SvgUnexpectedErrorOutline as ReactComponent };
export default __webpack_public_path__ + "images/unexpected-error-outline.8281ff2b.svg";